// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".addressHeaderWrapper_j5fqX{display:flex;justify-content:space-between;font-size:larger;font-weight:700}.addressHeaderWrapper_j5fqX .lnk_3tETl{color:#7123d9;cursor:pointer;text-transform:uppercase}.addressButtons_2Ejls{margin-top:15px}.formSave_23ygI{margin-bottom:15px}.nsAddressForm_3D72l .dateField_Jo-A2{max-width:120px}.nsAddressForm_3D72l h2{display:flex;justify-content:space-between;margin-bottom:15px}.hideElement_1-7CM{height:0;overflow:hidden}", ""]);
// Exports
exports.locals = {
	"addressHeaderWrapper": "addressHeaderWrapper_j5fqX",
	"lnk": "lnk_3tETl",
	"addressButtons": "addressButtons_2Ejls",
	"formSave": "formSave_23ygI",
	"nsAddressForm": "nsAddressForm_3D72l",
	"dateField": "dateField_Jo-A2",
	"hideElement": "hideElement_1-7CM"
};
module.exports = exports;
